module.exports = __webpack_public_path__ + "static/media/icon_globe.7ee27b8d.svg";